<template>
    <div @blur="open = false" class="rel {invalidField}>input.invalidField+.selectField">
        <input class="d:none" :id="id" type="text" :value="modelValue" v-bind="$attrs" />
        <div
            class="
                selectField r:8 p:13.5|16 w:100% b:1|solid|gray300 f:gray800 outline:none font-md bg:url(images/down_arrow.svg)|calc(100%-20px)|no-repeat cursor:pointer
                {b:1|solid|y500}:focus
                {f:gray400}::placeholder
                bg:gray100[disabled]
            "
            @click="open = !open"
        >
            <p class="pr:20 lines:1" v-if="current">{{ current.title }}</p>
            <p class="f:gray400 pr:20 lines:1" v-else>{{ placeholder }}</p>
        </div>
        <div class="w:100% abs bg:white r:8 shadow:0|0|12|#0000001A translateY(16) max-height:384 overflow:auto z:$(zindex-dropdown)" v-show="open">
            <div
                class="cursor:pointer font-md px:16 py:13.5 bg:gray100:hover"
                @click="open = false; $emit('update:modelValue', option.id)"
                :key="option"
                v-for="(option) of options"
            >
                <span class="lines:1 lh:21px h:21">{{ option.title }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        id: { default: () => nextId(), type: String },
        modelValue: { type: [Number, String] },
        options: { required: true, type: Array },
        placeholder: { type: String },
        rules: { default: {}, type: Object }
    });

    let validator;

    const open = ref(false);

    const current = computed(() => props.options.find((option) => option.id === props.modelValue));

    const apply = (target) => {
        const rules = Object.keys(props.rules).map((rule) => {
            const errorMessage = props.rules[rule];

            return typeof errorMessage === "object" ? { rule, ...errorMessage } : { rule, errorMessage };
        });

        validator = target;
        validator.addField(`#${props.id}`, rules);
    };

    const show = (message) => validator.showErrors({ [`#${props.id}`]: message });

    defineExpose({ apply, show });

    defineOptions({ inheritAttrs: false });
</script>
